import React, { useState } from 'react';
import {
 Table,
 TableBody,
 TableCell,
 TableContainer,
 TableHead,
 TableRow,
 Paper,
 Typography,
 TablePagination,
} from '@mui/material';
import { format, parseISO } from 'date-fns';

export default function HistoryBoxList({ orders }) {
 const [page, setPage] = useState(0);
 const [rowsPerPage, setRowsPerPage] = useState(5);
 const [selectedRow, setSelectedRow] = useState(null);

 
 const handleChangePage = (event, newPage) => {
    setPage(newPage);
 };

 const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
 };

 const handleRowClick = (rowId) => {
    setSelectedRow(selectedRow === rowId ? null : rowId);
 };

 return (
    <div>
      {orders ? (
        <>
          <Typography variant="h6" component="h6" style={{ marginBottom: '10px' }}>
            Historial de Pedidos
          </Typography>

          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                 <TableCell>ID Orden</TableCell>
                 <TableCell>Cliente</TableCell>
                 <TableCell>Fecha de pedido</TableCell>
                 <TableCell>Fecha de entrega</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orders?.length > 0 ?
                (orders.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((order) => (
                  order?.ordersDetail?.length >0 ?
                  (<React.Fragment key={order.id}>
                     <TableRow onClick={() => handleRowClick(order.id)} style={{ cursor: 'pointer' }}>
                       <TableCell>{order.id}</TableCell>
                       <TableCell>
                         {order?.ordersDetail[0]?.productPrice?.client?.name}
                       </TableCell>
                       <TableCell>{order.date_created ? format(parseISO(order.date_created), 'dd-MM-yyyy HH:mm:ss') : ''}</TableCell>
                       <TableCell>{order.date_delivery ? format(parseISO(order.date_delivery), 'dd-MM-yyyy HH:mm:ss') : 'INMEDIATA'}</TableCell>
                       <TableCell>{order.quantity}</TableCell>
                     </TableRow>
                     {selectedRow === order.id && (
                       <TableRow>
                         <TableCell colSpan={5} style={{ padding: '10px', backgroundColor: '#f0f0f0' }}>
                           <Table size="small">
                             <TableHead>
                               <TableRow>
                                 <TableCell>Referencia</TableCell>
                                 <TableCell>Cantidad</TableCell>
                                 <TableCell>Color</TableCell>
                                 <TableCell>Proceso</TableCell>
                                 <TableCell>Fecha Crudo</TableCell>
                                 <TableCell>Fecha Marcados</TableCell>
                                 <TableCell>Fecha Tintoreria</TableCell>
                                 <TableCell>Fecha Enrollado</TableCell>
                                 <TableCell>Fecha Despacho</TableCell>
                                 <TableCell>Fecha Remisionado</TableCell>
                               </TableRow>
                             </TableHead>
                             <TableBody>
                               {order.ordersDetail.map((od, index) => (
                                 <TableRow key={index}>
                                  <TableCell>{od.productPrice?.product?.ref}</TableCell>
                                  <TableCell>{od.quantity ? (od.quantity + ' ' + od.type_quantity) : ''}</TableCell>
                                  <TableCell>{od.color?.cod}</TableCell>
                                  <TableCell>{od.cod_process === 'DEFE' ? 'SIN PROCESO' : od.cod_process}</TableCell>
                                  <TableCell>{od.fecha_crudo ? format(parseISO(od.fecha_crudo), 'dd-MM-yyyy HH:mm:ss') : '-'}</TableCell>
                                  <TableCell>{od.fecha_marcados ? format(parseISO(od.fecha_marcados), 'dd-MM-yyyy HH:mm:ss') : '-'}</TableCell>
                                  <TableCell>{od.fecha_tintoreria ? format(parseISO(od.fecha_tintoreria), 'dd-MM-yyyy HH:mm:ss') : '-'}</TableCell>
                                  <TableCell>{od.fecha_enrollado ? format(parseISO(od.fecha_enrollado), 'dd-MM-yyyy HH:mm:ss') : '-'}</TableCell>
                                  <TableCell>{od.fecha_despachos ? format(parseISO(od.fecha_despachos), 'dd-MM-yyyy HH:mm:ss') : '-'}</TableCell>
                                  <TableCell>{od.fecha_remission ? format(parseISO(od.fecha_remission), 'dd-MM-yyyy HH:mm:ss') : '-'}</TableCell>
                                 </TableRow>
                               ))}
                             </TableBody>
                           </Table>
                         </TableCell>
                       </TableRow>
                     )}
                  </React.Fragment>
                  )
                  :
                  null
                 )))
                  :
                (<TableRow>
                  <TableCell>
                    <p>No hay ordenes con los parametros solicitados...</p>
                  </TableCell>
                </TableRow>
                )}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={orders.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </>
      ) : (
        'Cargando...'
      )}
    </div>
 );
}